import { OverlayRef } from '@angular/cdk/overlay';

export class SortDropdownOverlayRef {
  public constructor(private _overlayRef: OverlayRef) {}

  public close(): void {
    this._overlayRef.dispose();
  }
}
